// ENUM CLEAN UP
// eslint-disable-next-line no-restricted-syntax
export enum CancelType {
    Task = 0,
    CampaignTasks = 1,
}
